import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { BulletinPoiType, DealType } from 'utils/entities';
import { promotePrivateBulletin, PromotePrivateBulletinViewSource } from 'store/state/app/actions';

export function usePromote(bulletinId: string, bulletinType: BulletinPoiType, dealType: DealType, viewSource: PromotePrivateBulletinViewSource) {
  const dispatch = useDispatch();

  const handlePromoteClick = useCallback((event: React.MouseEvent, data: { timeLeft: number }) => {
    dispatch(promotePrivateBulletin({
      bulletinId,
      bulletinType,
      dealType,
      viewSource,
      isTimerStillRunning: data.timeLeft > 0,
    }));
  }, [ bulletinId, bulletinType, dealType, viewSource ]);

  return handlePromoteClick;
}
